export default function removeZero(number) {
  // redux form stores numbers as string
  return number.charAt(0) === '0' ? number.substring(1) : number
}
